import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { Person } from './person-entity';
import { Visit } from './visit-entity';
import { Kpi } from '../control-tables/kpi-entity';
import { Device } from '../control-tables/device';
import { Branch } from '../control-tables/branch-entity';
import { Profile } from './profile-entity';
import { GeoArea } from '../control-tables/geo-area-entity';
import { TokenSerie } from '../control-tables/token-serie';
import { Warehouse } from './warehouse-entity';
import { RoleItinerary } from './role-itinerary-entity';


export class Role extends BaseEntity {

    roleCode        : string;
    name            : string;
    upRole          : Role;
    branch          : Branch;
    profile         : Profile;
    person          : Person;


  //  branchCode      : string;
  //  profileCode     : string;
  
    subRoles        : Role[] = [];
    online          : boolean;
    kpisDate        : Date;
    device          : Device; 
    currentCredit   : number;
    geoArea         : GeoArea;


    kpis            : Kpi[];
    firstOrLast     : number[];


    expanded        : boolean = false;
    visits		      : Visit[] = [];
    tokenSerie      : TokenSerie;

    warehouse           : Warehouse ;
    feededFromWarehouse : Warehouse ;

    roleItinerarys  : RoleItinerary[];   



    // Transient
    showChart     : boolean = true;

}